/** @jsxImportSource @emotion/react */

import { CSSRulesResolver } from "hooks/useCSSRulesWithTheme";

export const globalStyleClasses: CSSRulesResolver<{
  modalIsOpen?: boolean;
  overlayClickable?: boolean;
}> = ({ modalIsOpen, overlayClickable, colors }) => ({
  mobileRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",

    "@media (max-width: 600px)": {
      width: "100%",
      marginBottom: 8,
    },
  },
  mobileHide: {
    "@media (max-width: 600px)": {
      display: "none",
    },
  },
  select: {
    "@media (max-width: 600px)": {
      "> div > div": {
        flexGrow: 1,
        width: "100%",
      },
    },
  },
  closeButton: {
    position: "absolute",
    top: 16,
    right: 16,
  },
  modalContainer: {
    position: "fixed",
    inset: 0,
    width: "100%",
    height: "100%",
    zIndex: 10002,
    pointerEvents: modalIsOpen ? "auto" : "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modalOverlay: {
    position: "fixed",
    inset: 0,
    width: "100%",
    height: "100%",
    zIndex: 10003,
    background: "rgba(0, 0, 0, 0.5)",
    transition: "all 0.3s ease",
    transitionDelay: modalIsOpen ? "0.3s" : "0s",
    opacity: modalIsOpen ? 1 : 0,
    pointerEvents: modalIsOpen && overlayClickable ? "auto" : "none",
    cursor: "pointer",
  },
  modalGradient: {
    backgroundColor: colors.Hannibal[500],
    backgroundImage: `linear-gradient(90deg, rgb(255, 74, 193) 25%, rgb(144, 36, 255) 62%, rgb(255, 122, 0) 80%)`,
    height: 4,
  },
  modal: {
    position: "relative",
    width: 600,
    maxWidth: "90%",
    height: "auto",
    background: "white",
    zIndex: 10004,
    pointerEvents: modalIsOpen ? "auto" : "none",
    opacity: modalIsOpen ? 1 : 0,

    transform: modalIsOpen ? "translateY(0)" : "translateY(70px)",
    transition: "all 0.3s ease",
    transitionDelay: modalIsOpen ? "0.3s" : "0s",
    cursor: "auto",
    borderRadius: 16,
    maxHeight: "100%",
    overflow: "hidden",
    overflowY: "auto",
  },
  containerWithGradient: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    alignItems: "flex-start",
    justifyContent: "center",
    width: "100%",
    background: `linear-gradient(90deg, #F9FAFC 0%, #FFFFFF 100%)`,
    padding: 16,
    borderRadius: 16,
  },
});
